import { jsxs, jsx } from "react/jsx-runtime";
import { Button } from "../Components/ui/button.js";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "../Components/ui/tooltip.js";
import { cn } from "../lib/utils.js";
const Actions = ({ className, children, ...props }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn("tw:inline-flex tw:items-center tw:gap-2", className),
    ...props,
    children
  }
);
const Action = ({ tooltip, children, label, className, ...props }) => {
  const button = /* @__PURE__ */ jsxs(
    Button,
    {
      className: cn(
        "tw:relative tw:!size-6 tw:cursor-pointer tw:rounded-[8px] tw:bg-transparent tw:!p-0 tw:text-current tw:hover:bg-transparent tw:[&_svg]:!size-4",
        className
      ),
      type: "button",
      variant: "ghost",
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx("span", { className: "tw:sr-only", children: label || tooltip })
      ]
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsxs(Tooltip, { children: [
      /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
      /* @__PURE__ */ jsx(TooltipContent, { children: /* @__PURE__ */ jsx("p", { children: tooltip }) })
    ] }) });
  }
  return button;
};
export {
  Action,
  Actions
};
//# sourceMappingURL=actions.js.map
